export enum MarketingActionType {
    Offer = "offer",
    SponsoredAd = "sponsoredAd",
    Duo = "duo",
}
